export default {
    message: {
        tiers: {
            t1: {
                label: "Fristående",
                desc: "<p>Enhetlig tillgång till alla virtuella, webbaserade och SaaS-appar, skyddar användare, appar och data med heltäckande och kontextuella säkerhetskontroller.</p><p>Tillhandahåller VPN-fri proxy och SSO till webben, SaaS, virtuella och mobila appar, samt skydd mot skadligt innehåll, tangentloggare och skadlig programvara för skärmbildsfångst.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Heltäckande arbetsplatslösning för anställda som behöver en komplett digital arbetsplats med detaljerad säkerhet, men inte kräver virtuella appar och skrivbord.</p><p>Inkluderar funktionerna i Workspace Standard, plus avancerade säkerhetskontroller för SaaS och webb, enhetlig Endpoint Management och Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Omfattande arbetsplatslösning med hybrida implementeringsalternativ för Citrix Virtual Apps and Desktops.</p><p>Inkluderar funktionerna i Workspace Premium, plus ett molnhanteringsalternativ för Citrix Virtual Apps and Desktops.</p>"
            }
        }
    }
}